module.exports = __webpack_public_path__ + "static/media/IMG-8.2e5e745c.jpg";